import Optum from './Optum';
import SevenHills from './SevenHills';
import TestBrand from './TestBrand';
import AthenaTelehealth from './AthenaTelehealth';

export const contextConsentMap: { [index: string]: () => JSX.Element } = {
  '28621': Optum,
  '28622': Optum,
  '28623': Optum,
  '29963': Optum,
  athenaTelehealth: AthenaTelehealth,
  '14601': SevenHills,
  '1959': TestBrand,
};
